import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getLocalStorage } from "../../utils/localStorage";
import { DataGrid } from '@mui/x-data-grid';
import { Box } from "@mui/material";
import { findUserTickets } from "../../redux/action/ticketActions";
export const TicketsHistory = () => {
    const clientId = getLocalStorage("user").clientId;
    const [tickets, setTickets]  = useState([]);
    const dispatch = useDispatch();
    useEffect($ =>{
          dispatch(findUserTickets(clientId, setTickets)) ;
    }, [ dispatch, clientId])

    const columns = [
        {
            field: 'date',
            headerName: 'Date',
            width: 110,
        },
        
        {
            field: 'issue',
            headerName: 'Issue',
            width: 110,
        },
        {
            field: 'issueMessage',
            headerName: 'Query',
            width: 200,
        },
        {
             field: 'status',
            headerName: 'Status',
            width: 110,
        },
        {
            field: 'resolvedMessage',
           headerName: 'Message',
           width: 300,
       }   
    ]

    return <>
    <h3>History</h3>
       <Box
        sx={{
            height: 500, width: '1'
        }}
    >
        <DataGrid
            columns={columns}
            rows={tickets}
            rowHeight={70}
            getRowId={(row) => row._id}
        />
    </Box>

    </>
}
